"use client";

import { createContext, useState } from "react";
import KritikSaranDialog from "@/components/dialog/KritikSaranDialog";
import UjiCobaDialog from "@/components/dialog/UjiCobaDialog";
import AlertDialog from "@/components/dialog/AlertDialog";
import RekomendasiDialog from "@/components/dialog/RekomendasiDialog";

interface MenuContextType {
  stateUserMenu: { notifikasi: boolean };
  setStateUserMenu: React.Dispatch<React.SetStateAction<{ notifikasi: boolean }>>;
  stateKritikSaranDialog: boolean;
  setStateKritikSaranDialog: React.Dispatch<React.SetStateAction<boolean>>;
  state: {
    mainSideBar: boolean;
    subSideBarTentangKami: boolean;
    subSideBarFasilitas: boolean;
    subSideBarLayanan: boolean;
    subSideBarKoleksi: boolean;
    subSideBarBantuan: boolean;
  };
  setState: React.Dispatch<React.SetStateAction<{
    mainSideBar: boolean;
    subSideBarTentangKami: boolean;
    subSideBarFasilitas: boolean;
    subSideBarLayanan: boolean;
    subSideBarKoleksi: boolean;
    subSideBarBantuan: boolean;
  }>>;
  stateKoleksi: boolean;
  setStateKoleksi: React.Dispatch<React.SetStateAction<boolean>>;
  stateFilterKoleksi: boolean;
  setStateFilterKoleksi: React.Dispatch<React.SetStateAction<boolean>>;
  stateShareKoleksiDialog: boolean;
  setStateShareKoleksiDialog: React.Dispatch<React.SetStateAction<boolean>>;
  stateAppBar: {
    subAppBarTentangKami: boolean;
    subAppBarKoleksi: boolean;
    subAppBarBantuan: boolean;
    subAppBarFasilitas?: boolean;
    subAppBarLayanan?: boolean;
  };
  setStateAppBar: React.Dispatch<React.SetStateAction<{
    subAppBarTentangKami: boolean;
    subAppBarKoleksi: boolean;
    subAppBarBantuan: boolean;
    subAppBarFasilitas?: boolean;
    subAppBarLayanan?: boolean;
  }>>;
  stateListItem: {
    listItemFasilitas: boolean;
  };
  setStateListItem: React.Dispatch<React.SetStateAction<{
    listItemFasilitas: boolean;
  }>>;
  stateUjiCobaDialog: boolean;
  setStateUjiCobaDialog: React.Dispatch<React.SetStateAction<boolean>>;
  stateNoKunciDialog: boolean;
  setStateNoKunciDialog: React.Dispatch<React.SetStateAction<boolean>>;
  stateAlertDialog: {
    isOpen: boolean;
    title: string;
    content: string;
    severity: string;
  };
  setStateAlertDialog: React.Dispatch<React.SetStateAction<{
    isOpen: boolean;
    title: string;
    content: string;
    severity: string;
  }>>;
  rekomendasiDialog: boolean;
  setRekomendasiDialog: React.Dispatch<React.SetStateAction<boolean>>;
  id: string;
  setId: React.Dispatch<React.SetStateAction<string>>;
  type: string;
  setType: React.Dispatch<React.SetStateAction<string>>;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider = ({ children }) => {
  const [stateUserMenu, setStateUserMenu] = useState({
    notifikasi: false
  });
  const [stateKritikSaranDialog, setStateKritikSaranDialog] = useState(false);
  const [stateUjiCobaDialog, setStateUjiCobaDialog] = useState(false);
  const [stateNoKunciDialog, setStateNoKunciDialog] = useState(false);
  const [stateAlertDialog, setStateAlertDialog] = useState({
    isOpen: false,
    title: "",
    content: "",
    severity: ""
  });
  const [rekomendasiDialog, setRekomendasiDialog] = useState(false);
  const [id, setId] = useState("1");
  const [type, setType] = useState("");
  const [state, setState] = useState({
    mainSideBar: false,
    subSideBarTentangKami: false,
    subSideBarFasilitas: false,
    subSideBarLayanan: false,
    subSideBarKoleksi: false,
    subSideBarBantuan: false
  });
  const [stateKoleksi, setStateKoleksi] = useState(false);
  const [stateFilterKoleksi, setStateFilterKoleksi] = useState(false);
  const [stateShareKoleksiDialog, setStateShareKoleksiDialog] = useState(false);
  const [stateAppBar, setStateAppBar] = useState({
    subAppBarTentangKami: false,
    subAppBarKoleksi: false,
    subAppBarLayanan: false,
    subAppBarBantuan: false
  });
  const [stateListItem, setStateListItem] = useState({
    listItemFasilitas: false
  });

  return (
    <MenuContext.Provider
      value={{
        stateUserMenu,
        setStateUserMenu,
        stateKritikSaranDialog,
        setStateKritikSaranDialog,
        state,
        setState,
        stateKoleksi,
        setStateKoleksi,
        stateFilterKoleksi,
        setStateFilterKoleksi,
        stateShareKoleksiDialog,
        setStateShareKoleksiDialog,
        stateAppBar,
        setStateAppBar,
        stateListItem,
        setStateListItem,
        stateUjiCobaDialog,
        setStateUjiCobaDialog,
        stateNoKunciDialog,
        setStateNoKunciDialog,
        stateAlertDialog,
        setStateAlertDialog,
        rekomendasiDialog,
        setRekomendasiDialog,
        id,
        setId,
        type,
        setType
      }}
    >
      {children}
      <KritikSaranDialog/>
      <UjiCobaDialog/>
      <AlertDialog/>
      <RekomendasiDialog/>
    </MenuContext.Provider>
  );
};

export default MenuContext;
